// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Rent
export const getRentsList = createAsyncThunk('appRents/getRentsList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.get(apiLink('getRentsList', params))
   return {
      params,
      data: response.data.rents,
      totalPages: response.data.total_elements
   }
})
export const getRent = createAsyncThunk('appRents/getRent', async id => {
   const response = await axios.get(apiLink({name: 'getRent', value: id}))
   return response.data
})
export const addRent = createAsyncThunk('appRents/addRent', async (data, { rejectWithValue }) => {
   try {
      const response = await axios.post(apiLink('addRent'), data)
      return response.data
   } catch (error) {
      return rejectWithValue(error.response?.data)
   }
})
export const addDynamicDeposit = createAsyncThunk('appRents/addDynamicDeposit', async data => {
   const id = data.rent_id
   delete data.rent_id
   const response = await axios.post(apiLink({name: 'addDynamicDeposit', value: id}), data)
   return response.data
})
export const addRentPeriodDetails = createAsyncThunk('appRents/addRentPeriodDetails', async data => {
   const id = data.id
   delete data.id
   const response = await axios.put(apiLink({name: 'addRentPeriodDetails', value: id}), data)
   return response.data
})
export const closeRentPeriod = createAsyncThunk('appRents/closeRentPeriod', async id => {
   const response = await axios.put(apiLink({name: 'closeRentPeriod', value: id}))
   return response.data
})
export const createRentPeriod = createAsyncThunk('appRents/createRentPeriod', async id => {
   const response = await axios.post(apiLink({name: 'createRentPeriod', value: id}))
   return response.data
})
export const shiftRentPeriod = createAsyncThunk('appRents/shiftRentPeriod', async params => {
   const id = params.id
   delete params.id
   const response = await axios.post(apiLink({name: 'shiftRentPeriod', value: id}, params))
   return response.data
})
export const setLastRentPeriod = createAsyncThunk('appRents/setLastRentPeriod', async params => {
   const id = params.id
   delete params.id
   const response = await axios.put(apiLink({name: 'setLastRentPeriod', value: id}, params))
   return response.data
})
export const updateActualPeriodPrice = createAsyncThunk('appRents/updateActualPeriodPrice', async params => {
   const id = params.id
   delete params.id
   const response = await axios.put(apiLink({name: 'updateActualPeriodPrice', value: id}, params))
   return response.data
})

export const setRentPrice = createAsyncThunk('appRents/setRentPrice', async (params) => {
   const id = params.id
   delete params.id
   const response = await axios.put(apiLink({name: 'setRentPrice', value: id}, params))      
   return response.data
})
export const stopRent = createAsyncThunk('appRents/stopRent', async (data, { rejectWithValue }) => {   
   try {
      const response = await axios.delete(apiLink({name: 'stopRent', value: data.id}, {end_date_time: data.end_date_time}))
      return response.data
   } catch (error) {
      return rejectWithValue(error.response?.data)
   }
})
export const deleteCurrentPeriod = createAsyncThunk('appRents/deleteCurrentPeriod', async (id) => {
   const response = await axios.delete(apiLink({name: 'deleteCurrentPeriod', value: id}))
   return response.data
})
export const clearCurrentPeriod = createAsyncThunk('appRents/clearCurrentPeriod', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/rent/clear-current-period?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const shiftRentPeriodLastDate = createAsyncThunk('appRents/shiftRentPeriodLastDate', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/rent/shift-period-last-date?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const getRentDetails = createAsyncThunk('appRents/getRentDetails', async rent_id => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/get-details?env=${process.env.REACT_APP_NODE_ENV}`, {
      rent_id,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const updateRentDetails = createAsyncThunk('appRents/updateRentDetails', async data => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/update-details?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

// ** Mark visit
export const rentPeriodVisited = createAsyncThunk('appRents/rentPeriodVisited', async data => {
   const id = data.period_id
   delete data.period_id
   const response = await axios.post(apiLink({name: 'rentPeriodVisited', value: id}, data))
   return response.data
})

// ** Payments
export const addPayment = createAsyncThunk('appRents/addPayment', async (data) => {
   return await axios.post(apiLink('addPayment'), data)
})
export const removeRentPayment = createAsyncThunk('appRents/removeRentPayment', async (id) => {
   const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'RENT'}))
   return response.data
})

// ** Deposit
export const removeDepositPayment = createAsyncThunk('appRents/removeDepositPayment', async (id) => {
   const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'DEPOSIT'}))
   return response.data
})
export const removeDynamicDeposit = createAsyncThunk('appRents/removeDynamicDeposit', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeDynamicDeposit', value: id}))
   return response.data
})

// ** Customers list
export const getRentCustomers = createAsyncThunk('appRents/getRentCustomers', async () => {
   const params = {active: true, sort_list: 'first_name', sort_order: 'ASC', rows: 1000, blacklist: false}
   const response = await axios.get(apiLink('getCustomersShortList', params))
   return response.data.customers
})
// ** Cars list
export const getRentCars = createAsyncThunk('appRents/getRentCars', async () => {
   const params = {sort_list: 'id', sort_order: 'ASC', rows: 1000, statuses: 'BASE,SHOWCASE', has_customer: false, in_road_accident_lock: false}
   const response = await axios.get(apiLink('getCarsShortList', params))
   return response.data.cars
})

// ** Rent Settings
export const getRentSettings = createAsyncThunk('appRents/getRentSettings', async () => {
   const response = await axios.get(apiLink('getRentSettings'))
   return response.data.rentSettings
})
export const addRentSettings = createAsyncThunk('appRents/addRentSettings', async (data) => {
   delete data.id
   const response = await axios.post(apiLink('addRentSettings'), data)
   return response.data
})
export const updateRentSettings = createAsyncThunk('appRents/updateRentSettings', async (data) => {
   const preset_id = data.id
   delete data.id
   const response = await axios.put(apiLink({name: 'updateRentsettings', value: preset_id}), data)
   return response.data
})
export const removeRentSettings = createAsyncThunk('appRents/removeRentSettings', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeRentSettings', value: id}))
   return response.data
})

// Media files
export const getMedia = createAsyncThunk('appRents/getMedia', async ({rent_id, types}) => {
   const response = await axios.post(apiLink('getFiles', {typeOwner: 'RENT'}), {
      ids: [rent_id],
      types
   })
   return {files: response.data.files, rent_id}
})
export const addMedia = createAsyncThunk('appRents/addMedia', async ({rent_id, type, typeOwner, file}) => {
   const response = await axios({
        method: "post",
        url: apiLink({name: 'uploadFile', value: rent_id}, {type, typeOwner}),
        data: { file },
        headers: { "Content-Type": "multipart/form-data" }
      })
   return response.data
})
export const removeMedia = createAsyncThunk('appRents/removeMedia', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeFile', value: id}, {typeOwner: 'RENT'}))
   return {id, status: response.status}
})

// ** Car replacement
export const carReplacement = createAsyncThunk('appRents/carReplacement', async (data) => {
   const id = data.id
   delete data.id
   const response = await axios.post(apiLink({name: 'carReplacement', value: id}), data)
   return response.data
})

// ** Rent pause / resume
export const setRentPause = createAsyncThunk('appRents/setRentPause', async (data, { rejectWithValue }) => {
   try {
      const response = await axios.post(apiLink({name: 'rentPause', value: data.id}, {end_date_time: data.end_date_time}))
      return response.data
   } catch (error) {
      return rejectWithValue(error.response?.data)
   }
})
export const setRentResume = createAsyncThunk('appRents/setRentResume', async (data, { rejectWithValue }) => {
   const id = data.id
   delete data.id
   try {
      const response = await axios.post(apiLink({name: 'rentResume', value: id}), data)
      return response.data
   } catch (error) {
      return rejectWithValue(error.response?.data)
   }
})

// ** Daily report
export const rentDailyReport = createAsyncThunk('appRents/rentDailyReport', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/report/rent-daily?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Get actual car on date of rent
export const getActualCarByRentOnDate = createAsyncThunk('appRents/getActualCarByRentOnDate', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/rent/car-replacement?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Get rent period details
export const getPeriodDetails = createAsyncThunk('appRents/getPeriodDetails', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/rent/period-details-v2?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Change rent period billing period
export const changePeriodBillingPeriod = createAsyncThunk('appRents/changePeriodBillingPeriod', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/rent/change-period-billing-period?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Change rent period aggregator settings
export const changePeriodAggregatorSettings = createAsyncThunk('appRents/changePeriodAggregatorSettings', async (data, { rejectWithValue }) => {
   try {
      const response = await axios.post(`https://api.mfauto.com.ua/rent/change-period-aggregator-settings?env=${process.env.REACT_APP_NODE_ENV}`, data)
      if (response.data?.error !== undefined) {
         return rejectWithValue(response.data)
      }
      return response.data
   } catch (error) {
      return rejectWithValue(error.response?.data ?? { error: error.message })
   }
})

// ** Rents archive 
export const getRentsArchive = createAsyncThunk('appRents/getRentsArchive', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/rent/get-archive?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return {
      params: data,
      data: response.data.rents,
      totalPages: response.data.total_elements
   }   
})

// ** Rents scheduled 
export const getRentsScheduled = createAsyncThunk('appRents/getRentsScheduled', async data => {   
   data.page = data.page === 0 ? 0 : data.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/rent/get-scheduled?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return {
      params: data,
      data: response.data.rents,
      totalPages: response.data.total_elements
   }   
})
export const getScheduledRent = createAsyncThunk('appRents/getScheduledRent', async id => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/get-scheduled-rent?env=${process.env.REACT_APP_NODE_ENV}`, {
      id,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const addScheduledRent = createAsyncThunk('appRents/addScheduledRent', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/add-scheduled?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const updateScheduledRent = createAsyncThunk('appRents/updateScheduledRent', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/update-scheduled?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const confirmRentScheduled = createAsyncThunk('appRents/confirmRentScheduled', async (id) => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/confirm-scheduled?env=${process.env.REACT_APP_NODE_ENV}`, {
      id,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const cancelRentScheduled = createAsyncThunk('appRents/cancelRentScheduled', async (id) => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/cancel-scheduled?env=${process.env.REACT_APP_NODE_ENV}`, {
      id,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const updateActualPeriodPriceDescription = createAsyncThunk('appRents/updateActualPeriodPriceDescription', async data => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/update-actual-period-price-description?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

// ** Rent checkup
export const getRentCheckup = createAsyncThunk('appRents/getRentCheckup', async rent_id => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/get-rent-checkup?env=${process.env.REACT_APP_NODE_ENV}`, {
      rent_id,
      token: localStorage.getItem('token')
   })
   return response.data
})

// ** Get next rent contract number
export const getNextRentContractNumber = createAsyncThunk('appRents/getNextRentContractNumber', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/get-next-contract-number?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Car Rents report
export const getCarsRentsReport = createAsyncThunk('appFinances/getCarsRentsReport', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/report/car-rents?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

export const getCarRentDetails = createAsyncThunk('appFinances/getCarRentDetails', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/report/car-rents-details?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

export const getPercentDriversReport = createAsyncThunk('appFinances/getPercentDriversReport', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/report/percent-drivers?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

// ** Add additional driver
export const addAdditionalDriver = createAsyncThunk('appRents/addAdditionalDriver', async data => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/additional-driver/add?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const removeAdditionalDriver = createAsyncThunk('appRents/removeAdditionalDriver', async data => {
   const response = await axios.post(`https://api.mfauto.com.ua/rent/additional-driver/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const appRentsSlice = createSlice({
   name: 'appRents',
   initialState: {
      data: [],
      scheduled: [],
      total: 1,
      params: {},
      settings: [],
      selectedRent: null,
      customers: [],
      cars: [],
      media: []
   },
   reducers: {},
   extraReducers: builder => {
      builder
         .addCase(getRentsList.fulfilled, (state, action) => {
            state.data = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
         })
         .addCase(getRentsArchive.fulfilled, (state, action) => {
            state.data = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
         })
         .addCase(getRentsScheduled.fulfilled, (state, action) => {
            state.scheduled = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
         })
         .addCase(getRent.fulfilled, (state, action) => {
            state.selectedRent = action.payload
         })
         .addCase(getRentSettings.fulfilled, (state, action) => {
            state.settings = action.payload
         })
         .addCase(updateRentSettings.fulfilled, (state, action) => {
            state.settings = action.payload
         })
         .addCase(getRentCustomers.fulfilled, (state, action) => {
            state.customers = action.payload
         })
         .addCase(getRentCars.fulfilled, (state, action) => {
            state.cars = action.payload
         })
         .addCase(getMedia.fulfilled, (state, action) => {
            const uniqueMedia = [...state.media, ...action.payload.files].reduce((accumulator, current) => {
               if (!accumulator.find((item) => item.file_id === current.file_id)) {
                  accumulator.push(current)
               }
               return accumulator
            }, [])
            state.media = uniqueMedia.filter((item) => item.customer_id === action.payload.customer_id)
         })
         .addCase(removeMedia.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
               state.media = state.media.filter(item => item.file_id !== action.payload.id)
            }
         })
   }
})

export default appRentsSlice.reducer
